import type {
    ActivationAlertsContractSeoAlertType,
    ActivationAlertsContractTrafficType,
} from "@similarweb/pro-api-client";

export const alertTypeTranslationKeyMap: Record<ActivationAlertsContractSeoAlertType, string> = {
    NewKeywords: "activation.alerts.filters.alert-type.keywords",
    NewPages: "activation.alerts.filters.alert-type.landing-pages",
};

export const trafficTypeTranslationKeyMap: Record<ActivationAlertsContractTrafficType, string> = {
    Organic: "activation.alerts.filters.traffic-type.organic",
    Paid: "activation.alerts.filters.traffic-type.paid",
};
